module.exports = function (trolleyService) {
    return {
        restrict: 'E',
        scope: {
            productDetails: '=product'
        },
        link(scope) {
            function init() {
                scope.isUpdating = false;
            }

            scope.error = init;
            scope.loading = function () {
                scope.isUpdating = true;
            };

            scope.remove = function () {
                scope.isDeleting = true;
                trolleyService
                    .removeTrolleyItem(scope.trolleyItem.Stockcode);
            };

            init();
        },
        template: require('./detail-item-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/common/detail-item-directive.js
 **/